import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/cms/ui/alert-dialog";
import { TextLink } from '@/components/ui/text-button';
import { Note } from '@/components/ui/note';

interface StoryLockedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  storyName: string;
  currentPlan: string;
  maxStories: number;
}

export function StoryLockedDialog({
  open,
  onOpenChange,
  storyName,
  currentPlan,
  maxStories
}: StoryLockedDialogProps) {

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="cursor-default select-none">
        <AlertDialogHeader>
          <AlertDialogTitle>This Story is Locked</AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogBody>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                <span className="font-semibold">{storyName}</span> has been locked because you've exceeded your plan's limit.
              </p>

              <p>
                Your <span className="font-semibold">{currentPlan.charAt(0).toUpperCase() + currentPlan.slice(1)}</span> plan keeps your {maxStories} most recently updated {maxStories === 1 ? 'story' : 'stories'} editable. Older stories are automatically locked to keep you within your plan limits.
              </p>

              <Note>
                <p className="text-lureo-14 font-medium mb-2 leading-5">What can you do?</p>
                <ul className="text-lureo-14 space-y-1 list-disc list-inside text-lureo-ink-subtle leading-5">
                  <li>Delete one of your draft stories</li>
                  <li>Upgrade your plan for more editable stories</li>
                  <li>
                    Contact the Lureo team on{' '}
                    <TextLink href="https://discord.gg/ZrthQXgp5a" target="_blank" rel="noopener noreferrer">
                      Discord
                    </TextLink>
                    {' '}for assistance
                  </li>
                </ul>
              </Note>
            </div>
          </AlertDialogDescription>
        </AlertDialogBody>

        <AlertDialogFooter>
          <AlertDialogCancel>Got it</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
